import type {
  EventName,
  WorkflowBaseTriggerDTO,
  WorkflowTriggerType,
} from '../workflowBaseTrigger.types';
import type { TenantSimple } from '@repositories/tenantRepository/tenant.types';
import { TenantSimpleModel } from '@repositories/tenantRepository/models/TenantSimpleModel';
import { WorkflowBaseTriggerFieldDTOModel } from './WorkflowBaseTriggerFieldDTOModel';

export class WorkflowBaseTriggerDTOModel {
  private readonly _dto: WorkflowBaseTriggerDTO;
  private readonly _fields: WorkflowBaseTriggerFieldDTOModel[];
  private _name: string;
  private readonly _tenant: TenantSimpleModel;

  constructor(dto: WorkflowBaseTriggerDTO) {
    this._dto = dto;
    this._fields = dto.fields?.length ? dto.fields.map(field => new WorkflowBaseTriggerFieldDTOModel(field)) : [];
    this._name = dto.name || '';
    this._tenant = new TenantSimpleModel(dto.tenant ?? {} as TenantSimple);
  }

  get originDTO(): WorkflowBaseTriggerDTO {
    return this._dto;
  }

  get description(): string {
    return this._dto.description || '';
  }

  get eventName(): EventName {
    return this._dto.eventName || 'TENANT_MEMBER_JOINED';
  }

  get fields(): WorkflowBaseTriggerFieldDTOModel[] {
    return this._fields;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get name(): string {
    return this._name;
  }

  set name(name: string) {
    this._name = name;
  }

  get tenant(): TenantSimpleModel {
    return this._tenant;
  }

  get type(): WorkflowTriggerType {
    return this._dto.type || 'DIRECT_API_TRIGGER';
  }

  /**
   * 1. 새로운 구성원이 추가되었을 때가 아닌 경우
   * 2. 구성원이 탈퇴되었을 때가 아닌 경우
   */
  get isConfigurable() {
    return !(this._dto.eventName === 'TENANT_MEMBER_JOINED' || this._dto.eventName === 'TENANT_MEMBER_LEFT');
  }
}
